import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";

import {
  StyledTableCell,
  StyledTableRow,
} from "components/atoms/table/StyledTable";

const ReportLocationDensityTable = (props) => {
  const rows = props.rows;
  const rowsLength = rows.length;

  if (rowsLength === 0) {
    return (
      <Typography sx={{ color: "error.main" }}>Não há registros.</Typography>
    );
  } else {
    const cells = rows.map((row) => {
      const val = Object.values(row);
      const columnsStrings = val.slice(2);
      const columnsNumbers = columnsStrings.map((str) => Number(str));
      const sumColumn = columnsNumbers.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );

      return (
        <StyledTableRow key={row.Divisao} id={row.Divisao}>
          <StyledTableCell>{row.Unidade}</StyledTableCell>
          <StyledTableCell>{row.Divisao}</StyledTableCell>
          <StyledTableCell>{val[2]}</StyledTableCell>
          <StyledTableCell>{val[3]}</StyledTableCell>
          <StyledTableCell>{val[4]}</StyledTableCell>
          <StyledTableCell>{val[5]}</StyledTableCell>
          <StyledTableCell>{val[6]}</StyledTableCell>
          <StyledTableCell>{val[7]}</StyledTableCell>
          <StyledTableCell>{val[8]}</StyledTableCell>
          <StyledTableCell>{val[9]}</StyledTableCell>
          <StyledTableCell>{val[10]}</StyledTableCell>
          <StyledTableCell>{val[11]}</StyledTableCell>
          <StyledTableCell>{val[12]}</StyledTableCell>
          <StyledTableCell>{val[13]}</StyledTableCell>
          <StyledTableCell>{val[14]}</StyledTableCell>
          <StyledTableCell>{val[15]}</StyledTableCell>
          <StyledTableCell>{val[16]}</StyledTableCell>
          <StyledTableCell>{sumColumn}</StyledTableCell>
        </StyledTableRow>
      );
    });
    return (
      <Box sx={{ mb: 2 }}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="tabela de recursos">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Unidade</StyledTableCell>
                <StyledTableCell>Departamento</StyledTableCell>
                <StyledTableCell>07h</StyledTableCell>
                <StyledTableCell>08h</StyledTableCell>
                <StyledTableCell>09h</StyledTableCell>
                <StyledTableCell>10h</StyledTableCell>
                <StyledTableCell>11h</StyledTableCell>
                <StyledTableCell>12h</StyledTableCell>
                <StyledTableCell>13h</StyledTableCell>
                <StyledTableCell>14h</StyledTableCell>
                <StyledTableCell>15h</StyledTableCell>
                <StyledTableCell>16h</StyledTableCell>
                <StyledTableCell>17h</StyledTableCell>
                <StyledTableCell>18h</StyledTableCell>
                <StyledTableCell>19h</StyledTableCell>
                <StyledTableCell>20h</StyledTableCell>
                <StyledTableCell>21h</StyledTableCell>
                <StyledTableCell>Total</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>{cells}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
};

ReportLocationDensityTable.propTypes = {
  rows: PropTypes.array.isRequired,
};

export default ReportLocationDensityTable;
